import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../Components/OrderStatusAndBilling/OrderHistory.scss";
import axios from "axios";
import Requirements from "../../Components/OrderStatusAndBilling/Requirements";
import PaymentDetails from "../../Components/OrderStatusAndBilling/PaymentDetails";
import TutorEngagement from "../../Components/OrderStatusAndBilling/TutorEngagement";
import Solution from "../../Components/OrderStatusAndBilling/Solution";
import ChatFAB from "../../Components/Chat/ChatFAB.jsx";
import { getSocket } from "../../utils/socket";
import { getPurchaseCourseById } from "../../services/getPurchaseCourse.js";
const apiEndPoint = process.env.REACT_APP_API;
const DashboardOrd = () => {
  const [data, setData] = useState({});
  const [isAddressAvailable, setIsAddressAvailable] = useState(false);
  const { questionId } = useParams();
  const fetchData = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      if (localStorage.getItem("serviceType") === "HomeworkHelp") {
        const response = await axios.get(
          `${apiEndPoint}student/homeworkHelp/getQuestionDetailByID/${questionId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const data = response?.data;
        setData(data.question);
        setIsAddressAvailable(data.billingDetails);
      } else if (localStorage.getItem("serviceType") === "AssignmentHelp") {
        const response = await axios.get(
          `${apiEndPoint}student/assignmentHelp/getQuestionDetailByID/${questionId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const data = response?.data;
        setData(data.question);
        setIsAddressAvailable(data.billingDetails);
      } else if (localStorage.getItem("serviceType") === "LiveSessionHelp") {
        const response = await axios.get(
          `${apiEndPoint}student/liveSessionHelp/getQuestionDetailByID/${questionId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const data = response?.data;
        setData(data.question);
        setIsAddressAvailable(data.billingDetails);
      } else if (localStorage.getItem("serviceType") === "CourseHelp") {
        const response = await getPurchaseCourseById(questionId);
        const data = response?.data;
        setData(data);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [questionId]);

  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;

    const handlePaymentUpdate = (paymentData) => {
      if (paymentData.orderId === data?.displayId) {
        fetchData();
      }
    };

    socket.on("payment-request", handlePaymentUpdate);
    socket.on("payment-confirmed", handlePaymentUpdate);

    return () => {
      socket.off("payment-request", handlePaymentUpdate);
      socket.off("payment-confirmed", handlePaymentUpdate);
    };
  }, [data?.displayId]);
  return (
      <div >
        <div className="content-wrapper" >
          <h4 className="title">Confirm & Pay</h4>
          <h6 className="subTitle pb-4">
            {data?.paymentSection
              ?.replace(/LiveSessionHelp/g, "Live Session Help")
              .replace(/AssignmentHelp/g, "Assignment Help")
              .replace(/HomeworkHelp/g, "Homework Help")}
          </h6>



  <div className="d-flex justify-content-center">
  <div className="white-bg mt-4" style={{ width: "60%" }}>
    <Requirements questionData={data} />
  </div>
</div>


<div className="d-flex justify-content-center">
          <div className="white-bg mt-4" style={{ width: "60%" }}>
            <PaymentDetails
              questionData={data}
              fetchData={fetchData}
              disable={false}
              isAddressAvailable={isAddressAvailable}
            />
          </div>
</div>

<div className="d-flex justify-content-center">
          <div className="white-bg mt-4" style={{ width: "60%" }}>
            <TutorEngagement disable={true} />
          </div>
</div>

<div className="d-flex justify-content-center">

          <div className="white-bg mt-4" style={{ width: "60%" }}>
            <Solution disable={true} />
          </div>
</div>
        </div>
        {data?.displayId && (
          <ChatFAB
            orderId={data.displayId}
            orderTitle={`Order #${data.displayId}`}
            autoOpen={true}
            onOrderUpdate={fetchData}
            orderCategory={localStorage.getItem("serviceType") || ""}
          />
        )}
      </div>
  );
};

export default DashboardOrd;
